let Backbone = require("backbone");

let main = function (Backbone) {
    var Tables = Backbone.Collection.extend({
        /**
         * Find tables that is not web table
         * @returns {Backbone.Collection}
         */
        unWebTables: function(){
            var result = new Backbone.Collection();
            this.each(function (it) {
                if (!it.isWebTable()) {
                    result.add(it);
                }
            });
            return result;
        }
    });
    return new Tables();
};

let exportedValue = main(Backbone);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/collection/TableCollection.js